import http from 'apis/config/http-service';
import { useCallback } from 'react';

// Restaurant search for the inquiry restaurant picker (ChakraAsyncSelect), on qsupply/backend's CMS restaurant list.
const endpoint = 'api/v1/restaurants';

export interface RestaurantOption {
  value: number; // restaurantId
  label: string;
}

export function useSearchRestaurantsApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: RestaurantOption[]) => void) => {
    http
      .get(endpoint, {
        params: { page: 1, limit: 20, sort: 'nameEn.asc', name: inputValue.trim() || undefined },
      })
      .then(({ data }) => {
        const list: Record<string, any>[] = data?.data ?? (Array.isArray(data) ? data : []);
        callback(list.map((r) => ({ value: r.id, label: r.name ?? r.nameEn ?? `Restaurant #${r.id}` })));
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
